import { areDatesEqual } from './dateHelper';

export const getUniqueValueOrUndefined = <T extends Date | string | undefined>(values: T[]): T | undefined => {
    if (values.length === 0) {
        return undefined;
    }

    const [firstValue, ...remainingValues] = values;

    return remainingValues.every((value) => areDatesEqual(firstValue, value)) ? firstValue : undefined;
};
